var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31696 1.93999C9.56104 1.69591 9.56104 1.30018 9.31696 1.05611C9.07288 0.812027 8.67716 0.812027 8.43308 1.05611L4.87306 4.61612L1.31305 1.05611C1.06897 0.812027 0.673246 0.812027 0.429169 1.05611C0.185091 1.30018 0.185091 1.69591 0.429169 1.93999L3.98918 5.5L0.429152 9.06003C0.185074 9.30411 0.185074 9.69984 0.429152 9.94391C0.67323 10.188 1.06896 10.188 1.31304 9.94391L4.87306 6.38388L8.43309 9.94391C8.67717 10.188 9.0729 10.188 9.31698 9.94391C9.56106 9.69984 9.56106 9.30411 9.31698 9.06003L5.75695 5.5L9.31696 1.93999Z",
    fill: "#8E8E93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.310dced511ea86554264df50683c2f11.svg";
export { ForwardRef as ReactComponent };